import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { BaseFieldProps, OptionSwitchField } from '@frontend/design-system';
import { SIDEBAR_BREAKPOINTS } from './constants';
import { DeviceSize } from './types';

type Props = BaseFieldProps<DeviceSize> & {
  trackingIdPrefix: string;
};

export const DeviceSizeField = ({ trackingIdPrefix, ...props }: Props) => {
  return (
    <OptionSwitchField
      name='display'
      css={css`
        button:hover {
          background-color: ${theme.colors.neutral5};
        }
        @media (max-width: ${SIDEBAR_BREAKPOINTS.mobile}px) {
          display: none;
        }
      `}
      {...props}
    >
      <OptionSwitchField.Option value='desktop' trackingId={`${trackingIdPrefix}-desktop-view-btn`}>
        <Icon name='computer' color={props.value === 'desktop' ? 'primary' : 'default'} css={iconStyle} />
      </OptionSwitchField.Option>
      <OptionSwitchField.Option value='mobile' trackingId={`${trackingIdPrefix}-mobile-view-btn`}>
        <Icon name='cell-phone' color={props.value === 'mobile' ? 'primary' : 'default'} css={iconStyle} />
      </OptionSwitchField.Option>
    </OptionSwitchField>
  );
};

const iconStyle = css`
  margin: ${theme.spacing(0, 1)};
  pointer-events: none;
`;
